var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound11ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 30,
  r: 9,
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  transform: "rotate(-180 39 30)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 29.992,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 20 29.992)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M15.757 34.234a6 6 0 0 1 0-8.485"
})));
SvgRound11ASelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound11ASelected);
export default ForwardRef;